<main data-aos="fade-in">
    <div class="back first-part" data-aos="dissapear" data-aos-anchor="#trigger" data-aos-anchor-placement="bottom-top">
        <div data-aos="grow" data-aos-duration="2500" class="red"></div>

        <img class="gif" src="assets/images/pdj.gif" alt="">
        <h2 data-aos="slide-in" i18n="@@subtitle-home">Paintings 1967-2021</h2>
    </div>
    <div class="second-part">
        <p id="trigger" i18n="@@home-third" class="review" data-aos="dissapear" data-aos-anchor="#trigger1"
            data-aos-anchor-placement="top-center"><span class="highlight">"</span>...He looks at the <span
                class="highlight">metaphysical</span> world (paradoxically) through the pop art prism
            of the mass media, which were the greatest
            threat to the survival of art and philosophy. Đorđević's imitation of a photographic frame, a bold but
            thoughtful
            gesture that proves that it is possible to combine the incompatible: art and the medium that destroys them
            <span class="highlight">"</span> Snežana
            Golubović 2006</p>
        <div id="trigger1" class="img img-first" data-aos="dissapear" data-aos-anchor="#trigger3"
            data-aos-anchor-placement="top-center"><a i18n="@@works-home-page" href="/works">Gallery</a></div>
        <p id="trigger3" i18n="@@home-first" class="review" data-aos="dissapear" data-aos-anchor="#trigger2"
            data-aos-anchor-placement="top-center"><span class="highlight">"</span>... Đorđević has enhanced his <span
                class="highlight">artistic</span> concept very early by the idea that it is possible to decompose a
            picture to
            many
            semantic layers including the interaction between different formally stylistic pattern. The reflexes of
            great
            European tradition starting from the Greeks , the reinessance and some typically modernistic patterns have
            not only
            thematically enriched his paintings , but also gave the artistic language itself a new dimension : both
            classic and
            modern in the
            same time…<span class="highlight">"</span><br />Sreto Bošnjak 2006</p>
        <div id="trigger2" class="img img-second" data-aos="dissapear" data-aos-anchor="#trigger4"
            data-aos-anchor-placement="top-center"><a i18n="@@about-home-page" href="/about">About</a></div>
        <p id="trigger4" i18n="@@home-second" class="review"><span class="highlight">"</span>.…Therefore, Đorđević’s
            paintings represent a
            formed and round <span class="highlight">vision</span>, a world of forms artistically justified, that can as
            soon as
            tomorrow be enriched by ideas which more and more appear to be an imperative of our time…<span
                class="highlight">"</span><br /> Pavle Vasić 1976</p>

        <div class="img img-third"><a i18n="@@contact-home-page" href="/contact">Contact</a></div>
    </div>
    <!-- <div class="third-part"></div> -->
</main>